module.exports = __webpack_public_path__ + "img/wrongmark.bb935489.svg";